import { Dispatch, useEffect, useMemo } from 'react';
import { actions } from '../../store/ducks/twilio';
import { showNotification } from '../../helpers/notification-helper';
import { useSelector } from 'react-redux';
import TStore from '../../types/store';
import { EVisitItem } from '../../types/e-visits';

export function useErrorHandling(
  dispatch: Dispatch<any>,
  formatMessage: (args: { id: string }) => string,
) {
  const twilioErrorMessage = useSelector((state: TStore) => state.twilio.twilioErrorMessage);

  useEffect(() => {
    if (twilioErrorMessage) {
      dispatch(actions.setErrorMessage(''));
      showNotification({
        type: 'ERROR',
        title: formatMessage({ id: twilioErrorMessage }),
        copy: '',
      });
    }
  }, [twilioErrorMessage, dispatch]);

  return {
    onError(error: Error, type: string) {
      console.log('TWILIO ERROR', { type, error });
      if (error.message === 'Requested device not found') {
        dispatch(actions.setPermissionError('twilio_no_device_found'));
      } else if (error.message === 'Permission denied') {
        dispatch(actions.setPermissionError('twilio_no_permission'));
      } else {
        dispatch(actions.setErrorMessage('twilio_error'));
      }
    },
  };
}

export function useParticipantNames(dispatch: Dispatch<any>, item: EVisitItem) {
  const currentUserProfile = useSelector((state: TStore) => state.users.currentUser?.profile);

  const localParticipantName = useMemo(() => {
    if (currentUserProfile) {
      return `${currentUserProfile.titleBeforeName || ''} ${currentUserProfile.firstName} ${
        currentUserProfile.lastName
      } ${currentUserProfile.titleAfterName || ''}`;
    }
    return '';
  }, [currentUserProfile]);

  const remoteParticipantName = useMemo(() => {
    const patientProfile = item.order?.patientProfile;
    if (patientProfile) {
      return `${patientProfile.titleBeforeName || ''} ${patientProfile.firstName} ${
        patientProfile.lastName
      } ${patientProfile.titleAfterName || ''}`;
    }
    return item.event.title || '';
  }, [item]);

  return { localParticipantName, remoteParticipantName };
}
